import type { CompactHeadlineResolved } from './types';
import { useSubstitute } from '@/lib/render/RenderContextProvider';

export function CompactHeadlineComponent({
  resolved,
}: {
  resolved: CompactHeadlineResolved;
}) {
  const sub = useSubstitute();
  const headline = resolved.headline ? sub(resolved.headline) : undefined;

  if (!headline) {
    return null;
  }

  return (
    <p className="text-primary lg:text-foreground m-0 mb-6 text-center text-base font-bold uppercase lg:text-2xl lg:font-medium lg:normal-case">
      {headline}
    </p>
  );
}
